import { createContext } from "react";
import { IConsultant } from "../models/IConsultant";

export const ConsultantContext = createContext<{ consultant: IConsultant | null; }>({ consultant: null });